// extracted by mini-css-extract-plugin
export default {"icon_position":"ReactDatePicker_icon_position__8ZM1Z"};